import { render } from "./ValueSection.vue?vue&type=template&id=39c590f5"
import script from "./ValueSection.vue?vue&type=script&lang=js"
export * from "./ValueSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__